module.exports = __webpack_public_path__ + "media/images/front/pc/routable/icon_demerit-18cddd449daac055c6649f2c243e0b15.svg";